﻿const validateLastName = () => {
    const digitsExactLength = document.querySelectorAll(
        "[digits-only-min-length]"
    );
    const digitsMaxLengthValue = digitsExactLength[0]?.getAttribute(
        "digits-only-max-length"
    );
    const digitsMinLengthValue = digitsExactLength[0]?.getAttribute(
        "digits-only-min-length"
    );
    const digitsExactMessageValue = digitsExactLength[0]?.getAttribute(
        "digits-only-error-message"
    );

    if (digitsMaxLengthValue && digitsExactMessageValue && digitsMinLengthValue) {
        const lastNameInput = document.querySelector("[digits-only-min-length]");
        const lastNameInputValue = lastNameInput.value;
        const regex = new RegExp(`^[0-9]{${digitsMinLengthValue},${digitsMaxLengthValue}}$`);
        const isLastNameMandatory = document.querySelector('#RequiredMarkerPatientLastName');
        const isLastNameEmpty = lastNameInputValue.trim() === '';
        const isValid = isLastNameMandatory
        ? regex.test(lastNameInputValue)
        : regex.test(lastNameInputValue) || isLastNameEmpty;

        return {
            isValid,
            message: digitsExactMessageValue,
        };
    }

    return {
        message: '',
        isValid: true
    }
}

const validateRegex = () => {
    const lastNameInput = document.querySelector("[digits-only-min-length]");

    // When last name is mandatory/optional and has digits only validation disabled then result should be as before our changes were made
    if (!lastNameInput) {
        return true;
    }

    document.querySelector('.is-invalid-last-name')?.remove();
    document
        .querySelector(".add_to_cart-hcp")
        ?.classList.remove("is-disabled");
    const { isValid, message } = validateLastName();

    if (!isValid) {
        let node = document.createElement("li");
        let textnode = document.createTextNode(message);
        node.appendChild(textnode);
        node.classList.add('is-invalid-last-name');
        document.querySelector('.configurator_summary__errors ul').appendChild(node);
        document.querySelector('.configurator_summary__errors').classList.remove('is-hidden');
        document
            .querySelector(".configurePatientInfo")
            .classList.add("has-error");
        document.querySelector("[digits-only-min-length]").classList.add("is-invalid");
        document
          .querySelector(".add_to_cart-hcp")
          ?.classList.add("is-disabled");

        return false;
    } else {
        return true;
    }
}

export function validation() {
    let debugFunction = false;

    let consoleInfo = 'background: #ECBE13; color: #fff; padding: 4px 10px;';
    let consoleParentTrue = 'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleParentTrueGap = 'background: #77AB59; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
    let consoleParentFalse = 'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;';
    let consoleParentFalseGap = 'background: #E35B5D; color: #fff; padding: 4px 10px;border-left:40px solid white;margin-bottom:20px;';
    let consoleChildTrue = 'background: #77AB59; color: #fff; padding: 2px 10px;border-left:80px solid white;';
    let consoleChildFalse = 'background: #E35B5D; color: #fff; padding: 2px 10px;border-left:80px solid white;';

    if (debugFunction) { console.log('%c Validation ', consoleInfo); }

    let requiredQuestions = document.querySelectorAll('.is-required');
    let checkPageQuestions = [];
    const addToCartBtn = document.querySelector('.add_to_cart-hcp');
    const summaryErrors = document.querySelector('.configurator_summary__errors');
    checkRequiredFields();

    // Default is to make button active
    // Then validation can decide if its enabled
    summaryErrors.classList.add('is-hidden');
    addToCartBtn ?.classList.remove('is-disabled');

    // Check if page is valid
    function checkPage(displayError) {
        if (debugFunction) { console.log('%c Questions not valid: ' + checkPageQuestions + ' ', consoleParentFalse); }
        if (checkPageQuestions.length === 0) {
            if (debugFunction) { console.log('%c Page is valid ', consoleParentTrueGap); }
            summaryErrors.classList.add('is-hidden');
            addToCartBtn?.classList.remove('is-disabled');
            return true;
        } else {
            if (debugFunction) { console.log('%c Page is not valid ', consoleParentFalseGap); }
            if(displayError) {
                summaryErrors.classList.remove('is-hidden');
                // Error position depends on sibling elements height
                let siblingHeight = window.getComputedStyle(document.querySelector('.cta_controller')).getPropertyValue('height');
                summaryErrors.style.bottom = siblingHeight;
                validateRegex();
            }
            addToCartBtn?.classList.add('is-disabled');
            return false;
        }
    }


    // This will/can be replaced on BE by using existing required functionality to add class server side
    requiredQuestions.forEach(question => {
        if (question.parentNode.style.display === 'none') {
            // The question is hidden so dont validate
        } else {
            question.parentNode.classList.add('is-required');
            question.parentNode.classList.add('is-required-wrapper');
        }
    });


    // On click
    // Loop through all h2's with required class
    // Find specific parent and apply class so we can target entire question
    // For each required question loop through inputs and find if its a text, select, checkbox etc
    // Check that input is valid on a question by question basis
    // If invalid assign that item to array for each specific question
    // Add help text to left for each question
    // If question is invalid assign it to an overal array for each errored question
    // As user fixes issues update array on each question
    // If question has no invalids remove it from overall array
    // When overall array is empty then page is valid

    function checkQuestionGeneric(displayError) {
        // Loop through all required questions
        let requiredWrappers = document.querySelectorAll('.is-required-wrapper');
        requiredWrappers.forEach((wrapper, i) => {
            let heading = wrapper.querySelector('h2').innerText.trim();

            let uniqueId = 'requiredItem' + i;

            // Bundled vs Unbundled
            let bundled = wrapper.querySelectorAll('input[type="checkbox"]');
            if (bundled.length > 0) {
                bundled = true;
            } else {
                bundled = false;
            }

            if (debugFunction) {
                console.log('%c ' + heading + ' Found ', consoleParentTrue);
                if (bundled) {
                    console.log('%c ' + heading + ' Bundled ', consoleParentTrue);
                }
            }

            let checkQuestionsInvalid = [];
            let itemsToValidate = [];
            let questionToValidateConditional = '';
            let errorMessageList = document.querySelector('.configurator_summary__errors ul');

            // For Inputs
            // e.g Patient Name, Chargers
            let inputFields = wrapper.querySelectorAll('input');
            inputFields.forEach((inputField, i) => {

                let inputFieldType = inputField.getAttribute('type');

                // Some inputs are hidden and should not be validated
                // Some inputs are display none after selecting other options, patient vs stock
                // e.g checkboxes for bundled receivers
                let isHidden = false;
                if (inputField.closest('.is-hidden') || inputField.closest('.configurator__section').style.display === 'none') {
                    isHidden = true;
                } else {
                    isHidden = false;
                }

                // If input type text and has .form-control class
                // e.g Patient Name
                if (inputFieldType === 'text' && inputField.classList.contains('form-control') && isHidden == false) {
                    // If inside Patient Details we can have some not required questions
                    if (inputField.closest('.configurePatientInfo')) {
                        // Make sure individual question is required
                        if (inputField.closest('.col-sm-12').querySelector('.label--required')) {
                            itemsToValidate.push(inputField);
                            if (inputField.value === '') {
                                if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                                if (inputField.closest('.form-group')) {
                                    displayError ? inputField.closest('.form-group').classList.add('is-invalid') : null;
                                } else {
                                    displayError ? inputField.closest('.col-sm-12').classList.add('is-invalid') : null;
                                }
                                checkQuestionsInvalid.push(wrapper);
                            } else {
                                if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                                if (inputField.closest('.form-group')) {
                                    inputField.closest('.form-group').classList.remove('is-invalid');
                                } else {
                                    inputField.closest('.col-sm-12').classList.remove('is-invalid');
                                }
                                // Check if an invalid question exists and remove it now that it is valid
                                let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                                if (findQuestion > 0) {
                                    checkQuestionsInvalid.splice(findQuestion, 1);
                                }
                            }
                            questionToValidateConditional = checkQuestionsInvalid.length > 0;
                        }
                    } else {
                        itemsToValidate.push(inputField);
                        if (inputField.value === '') {
                            if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                            if (inputField.closest('.form-group')) {
                                displayError ? inputField.closest('.form-group').classList.add('is-invalid') : null;
                            } else {
                                displayError ? inputField.closest('.col-sm-12').classList.add('is-invalid') : null;
                            }
                            checkQuestionsInvalid.push(wrapper);
                        } else {
                            if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                            if (inputField.closest('.form-group')) {
                                inputField.closest('.form-group').classList.remove('is-invalid');
                            } else {
                                inputField.closest('.col-sm-12').classList.remove('is-invalid');
                            }
                            // Check if an invalid question exists and remove it now that it is valid
                            let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                            if (findQuestion > 0) {
                                checkQuestionsInvalid.splice(findQuestion, 1);
                            }
                        }
                        questionToValidateConditional = checkQuestionsInvalid.length > 0;
                    }
                }

                // If input type text and has .number-input__field class but isnt inside a product-dropdown
                // For quantity questions where one selected quantity is enough
                // e.g Chargers Unbundled
                if (inputFieldType === 'text' && inputField.classList.contains('number-input__field') && !wrapper.querySelector('product-dropdown')) {
                    itemsToValidate.push(inputField);
                    if (inputField.value === '0') {
                        if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                        if(displayError) {
                            inputField.closest('.configurator__accessory-inner') ? inputField.closest('.configurator__accessory-inner').classList.add('is-invalid') : null;
                            inputField.closest('.number-input') ? inputField.closest('.number-input').classList.add('is-invalid') : null;
                        }
                        checkQuestionsInvalid.push(wrapper);
                    } else {
                        if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                        inputField.closest('.configurator__accessory-inner') ? inputField.closest('.configurator__accessory-inner').classList.remove('is-invalid') : null;
                        inputField.closest('.number-input') ? inputField.closest('.number-input').classList.remove('is-invalid') : null;
                        // Check if an invalid question exists and remove it now that it is valid
                        let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                        if (findQuestion > 0) {
                            checkQuestionsInvalid.splice(findQuestion, 1);
                        }
                    }
                    // If total items length is lower than invalid items length then the user has selected at least 1 checkbox
                    questionToValidateConditional = itemsToValidate.length <= checkQuestionsInvalid.length;
                }

                // If input type checkbox
                // For checkbox questions where one selected checkbox is enough
                // e.g Chargers Bundled
                if (inputFieldType === 'checkbox' && isHidden == false) {
                    itemsToValidate.push(inputField);
                    if (!inputField.checked) {
                        if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                        inputField.closest('.configurator__accessory-inner') && displayError ? inputField.closest('.configurator__accessory-inner').classList.add('is-invalid') : null;
                        checkQuestionsInvalid.push(wrapper);
                    } else {
                        if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                        inputField.closest('.configurator__accessory-inner') ? inputField.closest('.configurator__accessory-inner').classList.remove('is-invalid') : null;
                        // Check if an invalid question exists and remove it now that it is valid
                        let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                        if (findQuestion > 0) {
                            checkQuestionsInvalid.splice(findQuestion, 1);
                        }
                    }
                    // If total items length is lower than invalid items length then the user has selected at least 1 checkbox
                    questionToValidateConditional = itemsToValidate.length <= checkQuestionsInvalid.length;
                }

            })


            // For Selects
            // e.g Warranty
            // If select menu option is first item and that options value is blank then error
            let selectFields = wrapper.querySelectorAll('select');
            selectFields.forEach((selectField, i) => {

                if (selectField.closest('product-dropdown')) {
                    // Inside a product dropdown so do nothing
                } else if (selectField.closest('.configurator__accessories-filters')) {
                    // Inside a filter so do nothing
                } else {
                    // If inside Patient Details we can have some not required questions
                    if (selectField.closest('.configurePatientInfo')) {
                        // Make sure individual question is required
                        if (selectField.closest('.col-sm-12').querySelector('.label--required')) {
                            itemsToValidate.push(selectField);
                            if (selectField.options[selectField.selectedIndex].index === 0 && selectField.options[0].value === '') {
                                if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                                displayError ? selectField.closest('.form-select') ?.querySelector('.form-select__el') ?.classList.add('is-invalid') : null;
                                checkQuestionsInvalid.push(wrapper);
                            } else {
                                if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                                selectField.closest('.form-select') ?.querySelector('.form-select__el') ?.classList.remove('is-invalid');
                                // Check if an invalid question exists and remove it now that it is valid
                                let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                                if (findQuestion > 0) {
                                    checkQuestionsInvalid.splice(findQuestion, 1);
                                }
                            }
                            questionToValidateConditional = checkQuestionsInvalid.length > 0;
                        }
                    } else {
                        itemsToValidate.push(selectField);
                        if (selectField.options[selectField.selectedIndex].index === 0 && selectField.options[0].value === '') {
                            if (debugFunction) { console.log('%c Item ' + i + ' Not Valid ', consoleChildFalse); }
                            displayError ? selectField.closest('.form-select') ?.querySelector('.form-select__el') ?.classList.add('is-invalid') : null;
                            checkQuestionsInvalid.push(wrapper);
                        } else {
                            if (debugFunction) { console.log('%c Item ' + i + ' Valid ', consoleChildTrue); }
                            selectField.closest('.form-select') ?.querySelector('.form-select__el') ?.classList.remove('is-invalid');
                            // Check if an invalid question exists and remove it now that it is valid
                            let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                            if (findQuestion > 0) {
                                checkQuestionsInvalid.splice(findQuestion, 1);
                            }
                        }
                        questionToValidateConditional = checkQuestionsInvalid.length > 0;
                    }


                }
            })


            // For Selects Inside A Product Dropdown
            // e.g Domes, Receivers etc
            // Description
            // Find all product dropdowns
            //      forEach find content items
            //          forEach find all selects
            //              If select is invalid add it to array
            //                  Set content item to invalid
            //              If at least one select is valid
            //                  Set content item to valid
            //          If content item is invalid add it to array
            //              Set question to invalid
            // If all content items are valid
            //      Set question to valid
            // Notes
            // Only one select needs to be valid per content item
            // All content items needs to be valid as they represent Receiver left and right sides or for Domes no sides
            let findProductDropdowns = wrapper.querySelectorAll('product-dropdown');
            findProductDropdowns.forEach((productDropdown, i) => {
                let invalidContentItems = [];
                let findContentItems = productDropdown.querySelectorAll('.configurator__accessories-content_item');
                // Filter out hidden items such as those on another side
                let findContentItemsVisible = [...findContentItems].filter(element => !element.classList.contains('is-hidden'));
                // Filter out not selectable items due to other questions answered
                let findContentItemsSelectable = [...findContentItemsVisible].filter(element => !element.classList.contains('is-side-not-selectable'));
                findContentItemsSelectable.forEach((contentItem, i) => {
                    let findSelects = contentItem.querySelectorAll('select');
                    let invalidSelects = [];
                    let totalSelects = findSelects;
                    findSelects.forEach((select, i) => {
                        if (select.options[select.selectedIndex].index === 0) {
                            if (debugFunction) { console.log('%c Select ' + i + ' Not Valid ', consoleChildFalse); }
                            displayError ? select.closest('.configurator__accessory-inner').classList.add('is-invalid') : null;
                            invalidSelects.push(select);
                        } else {
                            if (debugFunction) { console.log('%c Select ' + i + ' Valid ', consoleChildTrue); }
                            select.closest('.configurator__accessory-inner').classList.remove('is-invalid');
                            // Check if an invalid select exists and remove it now that it is valid
                            let findSelect = invalidSelects.indexOf(select);
                            if (findSelect > 0) {
                                invalidSelects.splice(findSelect, 1);
                            }
                        }
                    })
                    if (totalSelects.length <= invalidSelects.length) {
                        if (debugFunction) { console.log('%c Content Item ' + i + ' Not Valid ', consoleChildFalse); }
                        invalidContentItems.push(contentItem);
                    } else {
                        if (debugFunction) { console.log('%c Content Item ' + i + ' Valid ', consoleChildTrue); }
                        // Check if an invalid content items exists and remove it now that it is valid
                        let findContentItem = invalidContentItems.indexOf(contentItem);
                        if (findContentItem > 0) {
                            invalidContentItems.splice(findContentItem, 1);
                        }
                        // As a select can techincally be invalid but not mean the overall question is invalid we need to remove the class for the styling
                        let findInvalids = contentItem.querySelectorAll('.is-invalid');
                        findInvalids.forEach((invalid, i) => {
                            invalid.classList.remove('is-invalid');
                        })
                    }
                })
                if (invalidContentItems.length > 0) {
                    if (debugFunction) { console.log('%c Product Dropdown ' + i + ' Not Valid ', consoleChildFalse); }
                    checkQuestionsInvalid.push(wrapper);
                } else {
                    if (debugFunction) { console.log('%c Product Dropdown ' + i + ' Valid ', consoleChildTrue); }
                    // Check if an invalid question exists and remove it now that it is valid
                    let findQuestion = checkQuestionsInvalid.indexOf(wrapper);
                    if (findQuestion > 0) {
                        checkQuestionsInvalid.splice(findQuestion, 1);
                    }
                }
                questionToValidateConditional = checkQuestionsInvalid.length > 0;
            })


            if (checkQuestionsInvalid.length > 0) {
                if (debugFunction) { console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildFalse); }
            } else {
                if (debugFunction) { console.log('%c Items not valid: ' + checkQuestionsInvalid.length, consoleChildTrue); }
            }


            if (questionToValidateConditional) {
                if (debugFunction) { console.log('%c ' + heading + ' Not Valid', consoleChildFalse); }
                // If error message already exists do nothing
                if (errorMessageList.querySelector('#' + uniqueId + '')) {
                    // Do nothing
                } else {
                    // Add errored questions
                    // We are using the string from the heading field as it is translatable
                    let node = document.createElement("li");
                    let textnode = document.createTextNode(heading);
                    node.appendChild(textnode);
                    node.setAttribute("id", uniqueId);
                    errorMessageList.appendChild(node);
                }
                // Add error class from parent question
                displayError ? wrapper.classList.add('has-error') : null;
                // If this string exists in the array dont push it again
                // -1 means it has not been found
                let findQuestion = checkPageQuestions.indexOf(uniqueId);
                if (findQuestion < 0) {
                    checkPageQuestions.push(uniqueId);
                }
            } else {
                if (debugFunction) { console.log('%c ' + heading + ' Valid ', consoleChildTrue); }
                // If error message exists remove it
                if (errorMessageList.querySelector('#' + uniqueId + '')) {
                    errorMessageList.querySelector('#' + uniqueId + '').remove();
                }
                // Remove error class from parent question
                wrapper.classList.remove('has-error');
                // If this string exists in the array remove it
                // -1 means it has not been found
                let findQuestion = checkPageQuestions.indexOf(uniqueId);
                if (findQuestion >= 0) {
                    checkPageQuestions.splice(findQuestion, 1);
                }
            }

        })

        // Check page is valid
        return checkPage(displayError);
    }

    // Submit button
    document.querySelector('.cta_controller .btn')?.addEventListener('click', (e) => {
        e.preventDefault();
        if (debugFunction) { console.log('%c Click Submit ', consoleInfo); }
        const isValid = checkQuestionGeneric(true);
        const isLastnameValid = validateRegex();

        if(isValid && isLastnameValid) {
            checkoutActions(e.target);
        }
    });

    /**
     * Checkout actions
     * 1. Show checkout modal
     * 2. Save and return to cart (when edit product from cart)
     */
    const checkoutActions = (elem) => {
        const saveAndReturnButtonId = elem.getAttribute('data-button-id');
        const isSaveAndReturn = elem.getAttribute('data-save-and-return');
        const isPostback = typeof(__doPostBack) === 'function';
        // Save and return to cart
        if (saveAndReturnButtonId && isSaveAndReturn == "1" && isPostback) {
            __doPostBack(saveAndReturnButtonId, '', true, '', '', false, false);
            return;
        }
        // Show checkout modal
        document.querySelector('.configurator_modal').showModal();
    }

    function checkRequiredFields() {
        if (requiredQuestions.length === 0) {
            addToCartBtn?.classList.remove('is-disabled');
        }
    }

    // Check on page load. Fix when return to configuration from edit product in cart
    checkQuestionGeneric(false);

    // detect change in required fields
    const requiredFields = [...document.querySelectorAll('.is-required-wrapper input, .is-required-wrapper select')];
    for (let field of requiredFields) {
        field.addEventListener('change', function () {
            checkQuestionGeneric(false);
        })
    };

    // Close error message
    const closeBtn = document.querySelector('.close_error_message');
    closeBtn?.addEventListener('click', () => {
        summaryErrors.classList.add('is-hidden');
    });

    const productBrand = document.querySelector(".product_brand");

    if (productBrand.innerText.trim() === "") {
        productBrand.style.display = "none";
    }
}
